// src/utils/uploadToCloudinary.js
import imageCompression from "browser-image-compression";
import axios from "axios"; // ❗ use direct axios (NOT your api instance)
import store from "../store";

export const uploadToCloudinary = async (
  file,
  folder = "avatars",
  index = 1,
  total = 1
) => {
  const cloudName = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
  const uploadPreset = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;

  try {
    store.dispatch({
      type: "UPLOAD_PROGRESS",
      payload: 0
    });

    store.dispatch({
      type: "UPLOAD_STEP",
      payload: { current: index, total },
    });

    const compressedFile = await imageCompression(file, {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    });

    const formData = new FormData();
    formData.append("file", compressedFile);
    formData.append("upload_preset", uploadPreset);
    formData.append("folder", folder);

    const { data } = await axios.post(
      `https://api.cloudinary.com/v1_1/${cloudName}/image/upload`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (progressEvent) => {
          if (!progressEvent.total) return;

          const percent = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );

          store.dispatch({
            type: "UPLOAD_PROGRESS",
            payload: percent,
          });

          // 👇 also store step info

        },
      }
    );

    return data.secure_url;

  } catch (error) {
    console.error("Upload error:", error);
    throw error;
  }
};